// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__DD6Bm","red":"Banner_red__KazVl","green":"Banner_green__3lxC1","blue":"Banner_blue__K0Ak9","minsk":"Banner_minsk__DXFjU","orange":"Banner_orange__NmZc6"};